import { useEffect } from "react"
import * as Sentry from "@sentry/react"
import { shouldSendToSentry } from "../utils/environment"
import { getOfferwallOrigin, redirectToOfferwall } from "../utils/offerwallRedirect"

/**
 * /offers в воронке — старые ссылки на её офферволл: уводим на офферволл во frontend-machine (с параметрами ссылки).
 * Если это уже домен офферволла, путь до frontend-machine не проксирован: новый редирект зациклился бы,
 * поэтому показываем пустую страницу и сообщаем в Sentry.
 */
export function OfferwallRedirect() {
  const onOfferwallDomain = getOfferwallOrigin() === window.location.origin

  useEffect(() => {
    if (!onOfferwallDomain) {
      redirectToOfferwall()
      return
    }
    console.error(
      "[offerwall] /offers reached the funnel on the offerwall domain: it must be routed to frontend-machine"
    )
    if (shouldSendToSentry()) {
      Sentry.captureMessage("Offerwall /offers reached the funnel instead of frontend-machine", {
        level: "error",
        tags: { type: "offerwall_not_routed" },
        extra: { url: window.location.href }
      })
    }
  }, [onOfferwallDomain])

  return null
}
